<div class="flex items-center gap-1">
  <button mat-icon-button (click)="navigateWeek(-1)" aria-label="Previous week" [disabled]="!hasValue()">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" [formGroup]="pickerForm">
    <mat-label>Select Week Range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate placeholder="Week start" formControlName="start" readonly>
      <input matEndDate placeholder="Week end" formControlName="end" readonly>
    </mat-date-range-input>

    @if (clearable() && hasValue()) {
      <button matSuffix mat-icon-button type="button" (click)="onClear()" matTooltip="Clear week filter">
        <mat-icon>close</mat-icon>
      </button>
    }

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <!-- (closed) fires exactly once per user interaction, after the strategy has
         set both start and end — avoids double-emit from (dateChange) on each input. -->
    <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
  </mat-form-field>

  <button mat-icon-button (click)="navigateWeek(1)" aria-label="Next week" [disabled]="!hasValue()">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
